import { DeviceMeta, CurrentUser } from 'Roblox';
import robuxModule from '../robuxModule';

function purchaseWarningModalController(
  $scope,
  $uibModalInstance,
  productType,
  premiumService,
  premiumConstants,
  eventStreamService
) {
  'ngInject';

  // record modal show
  const pageContext = premiumConstants.pageContext.purchaseWarningModal;
  const userAgent = DeviceMeta().appType;
  const { userId } = CurrentUser;
  const shownParams = {
    platform: userAgent,
    uid: userId,
    pid: productType.productId,
    from_pid: productType.premiumFeatureId
  };
  eventStreamService.sendModalEvent(
    pageContext,
    eventStreamService.modalActions.shown,
    shownParams
  );

  // Click on "OK"
  $scope.continue = function() {
    eventStreamService.sendModalEvent(pageContext, 'oKButton', shownParams);
    const link = document.createElement('a');
    link.href = premiumService.getPurchaseUrl(productType, premiumConstants.pageContext.robux);
    link.click();
    $uibModalInstance.close(true);
  };

  // Click on "Cancel"
  $scope.close = function() {
    eventStreamService.sendModalEvent(
      pageContext,
      eventStreamService.modalActions.dismissed,
      shownParams
    );
    $uibModalInstance.close(true);
  };
}

robuxModule.controller('purchaseWarningModalController', purchaseWarningModalController);

export default purchaseWarningModalController;
